import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BasicDetailsForm } from '@models/MLTC/BasicDetails.model';
import { CoverageForm } from '@models/MLTC/Coverage.model';
import { SQSPocketResponse } from '@models/MLTC/SQSPocketRequest.model';

export interface Step1State {
  basicDetails: BasicDetailsForm | null;
  coverage: CoverageForm | null;
  planSelection: string | null;
  pdfPath: string | null;

  sqsQuotation: SQSPocketResponse | null;
  quoteRawResponse: object | null;
  quoteRawRequest: object | null;
  appliedPromoCode: string;
  isCompleted: boolean;
}

const initialState: Step1State = {
  basicDetails: null,
  coverage: new CoverageForm(null),
  planSelection: 'CareShield Life',
  pdfPath: null,
  sqsQuotation: null,
  appliedPromoCode: '',
  quoteRawResponse: null,
  quoteRawRequest: null,
  isCompleted: false,
}

const step1Slice = createSlice({
  name: 'MLTC-Step1',
  initialState,
  reducers: {
    updateBasicDetails: (state, action: PayloadAction<BasicDetailsForm>) => {
      state.basicDetails = action.payload
    },
    updateCoverage: (state, action: PayloadAction<CoverageForm>) => {
      state.coverage = action.payload
    },
    updatePlanSelection: (state, action: PayloadAction<string>) => {
      state.planSelection = action.payload
    },
    updatePdfPath: (state, action: PayloadAction<string>) => {
      state.pdfPath = action.payload
    },
    updateSQSQuotation: (state, action: PayloadAction<SQSPocketResponse>) => {
      state.sqsQuotation = action.payload
    },
    updatePromoCode: (state, action: PayloadAction<string>) => {
      state.appliedPromoCode = action.payload
    },
    updateQuoteResponse: (state, action: PayloadAction<object>) => {
      state.quoteRawResponse = action.payload
    },
    updateQuoteRequest: (state, action: PayloadAction<object>) => {
      state.quoteRawRequest = action.payload
    },
    completeStep: (state, action: PayloadAction<boolean>) => {
      state.isCompleted = action.payload;
    }
  },
  extraReducers: {}
})

export const {
  updateBasicDetails,
  updateCoverage,
  updatePlanSelection,
  updatePdfPath,
  updateSQSQuotation,
  updatePromoCode,
  updateQuoteResponse,
  updateQuoteRequest,
  completeStep,
} = step1Slice.actions;

export default step1Slice.reducer;